/* eslint-disable no-unused-vars, comma-dangle, prefer-const, padded-blocks, no-else-return, no-lonely-if, newline-per-chained-call, quotes, eol-last */
import Vue from 'vue';
import Router from 'vue-router';
import firebase from 'firebase/app';
import { db } from '@/main';
import DashboardView from '@/views/dashboard';
import ProjectView from '@/views/project';
import AccountView from '@/views/account';
import AcceptInviteView from '@/views/accept-invite';
import LoginView from '@/views/login';
import ForgotView from '@/views/forgot';
import PrintView from '@/views/print';
import PrintVersionView from '@/views/printVersion';
import jwt, {JsonWebTokenError} from 'jsonwebtoken';

Vue.use(Router);
const path = window.location.pathname;
const queryString = window.location.search;

const projectId = path.split('/')[2];
const params = new URLSearchParams(queryString);
const uid = params.get('uid');
const router = new Router({
    mode: 'history',
    routes: [
        {
            path: '/login/:redirect?',
            name: 'login',
            props: true,
            component: LoginView
        },
        {
            path: '/forgot',
            name: 'forgot',
            props: true,
            component: ForgotView
        },
        {
            path: '/',
            name: 'home',
            component: DashboardView,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/dashboard',
            name: 'dashboard',
            component: DashboardView,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/account',
            name: 'account',
            component: AccountView,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/project/:id',
            name: 'project',
            component: ProjectView,
            props: true,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/project/:id/version/:version',
            name: 'projectVersion',
            component: ProjectView,
            props: true,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/invite/:id',
            name: 'acceptInvite',
            component: AcceptInviteView,
            props: true,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/project/:id/print/:layout',
            name: 'print',
            component: PrintView,
            props: true,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/project/:id/version/:versionId/print/:layout',
            name: 'printVersion',
            component: PrintVersionView,
            props: true,
            meta: {
                requiresAuth: true
            }
        }
    ],
});

router.beforeEach(async(to, from, next) => {
    let currentUser = firebase.auth().currentUser;
    let requiresAuth = to.matched.some(record => record.meta.requiresAuth);
    let requiresAdmin = to.matched.some(record => record.meta.requiresAdmin);
    const getCurrentUser = async () => {
        if (!currentUser) {
            try {
                const decoded = jwt.verify(uid, process.env.VUE_APP_SECRETKEY);
                const decryptedUserId = decoded.userId;
                const url = `https://us-central1-${process.env.VUE_APP_FIREBASE_PROJECTID}.cloudfunctions.net/getCurrentUserByUid`;
                const postData = { uid: decryptedUserId };
                try {
                    const response = await Vue.http.post(url, postData);
                    firebase.auth().signInWithCustomToken(response.data);
                    currentUser = response.data;
                    requiresAdmin = true;
                } catch (error) {
                    console.error('Error fetching current user:', error);
                }
            } catch (err) {
                if (err instanceof JsonWebTokenError) {
                    console.error('Token expired or invalid');
                } else {
                    console.error('An error occurred during authentication');
                }
            }
            
        }
        return currentUser;
    };

    // Await the current user fetch if necessary
    if (!currentUser) {
        await getCurrentUser();
    }
    if (requiresAdmin) {
        if (!currentUser) {
            next({
                path: '/login',
                query: { redirect: to.fullPath }
            });
        } else {
            if (uid && projectId) {
                next({
                    path: `/project/${projectId}`
                });
            } else {
                db.collection('users').doc(currentUser.uid).get().then((doc) => {
                    if (doc.exists) {
                        const userData = doc.data();
                        if (userData.admin) {
                            next();
                        } else {
                            next('/');
                        }
                    } else {
                        next('/');
                    }
                }).catch((error) => {
                    next('/');
                });
            }
        }
        return;
    }

    if (!currentUser && requiresAuth) {
        if (path.split('/')[1] === 'login' || uid) {
            next({
                path: `/login`,
                query: { projectId: projectId}
            });
        } else {
            next({
                path: `/login`,
                query: { redirect: '' }
            });
        }
        return;
    }

    if (to.name === 'project' && to.query.uid) {
        const { id } = to.params;
        if (id) {
            next(`/project/${id}`);
        }
    } else {
        next();
    }
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js